// Seeky failures sign out only the embed. Do not use the shared API helper,
// whose 401 handler logs the user out of the whole website.
export const getSeekyToken = async (url, signal) => {
  try {
    const response = await fetch(url, { credentials: 'include', signal });
    if (response.status !== 200) return null;
    const data = await response.json();
    return typeof data?.token === 'string' && data.token.trim() ? data.token : null;
  } catch {
    return null;
  }
};
